import styled from 'styled-components';

const Separator = styled.div`
  background: linear-gradient(#f8cb70, #F4D8A0, #FFF);
  height: 50px; 
`;
 
export default Separator;